import { useEffect, useState } from "react";
import { useBlockUI } from "../../../shared/services/block-ui-service";
import instance from "../../index";
import { BaseResponse } from "../../../models/base-response";
import { PagedList } from "../../../models/paged-list";
import { ShortDto } from "../../../models/short-dto";
import {CreateVehicleTypeRequest, UpdateVehicleTypeRequest} from "../../../models/requests/create-vehicle-type-request";
import {VehicleTypeFilters} from "../../../filters/vehicle-type-filters";
import {ReferenceGroup, VehicleType} from "../../../models/fleet-type";

const useVehicleTypeService = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const blockUI = useBlockUI();

    useEffect(() => {
        blockUI?.setActive(loading);
    }, [loading]);

    async function createVehicleType(request: Partial<CreateVehicleTypeRequest>) {
        const response = await instance.post("/v1/backoffice/vehicle-types", request);
        return response.data;
    }

    async function updateVehicleType(id: string, request: Partial<UpdateVehicleTypeRequest>) {
        const response = await instance.put(`/v1/backoffice/vehicle-types/${id}`, request);
        return response.data;
    }

    async function deleteVehicleType(id: string) {
        const response = await instance.delete(`/v1/backoffice/vehicle-types/${id}`);
        return response?.data;
    }

    async function activateVehicleType(id: string) {
        const response = await instance.put(`/v1/backoffice/vehicle-types/${id}/activate`);
        return response.data;
    }

    async function deactivateVehicleType(id: string) {
        const response = await instance.put(`/v1/backoffice/vehicle-types/${id}/deactivate`);
        return response.data;
    }

    async function getVehicleTypes(filter?: VehicleTypeFilters): Promise<PagedList<VehicleType>> {
        const response = await instance.get<BaseResponse<PagedList<VehicleType>>>("/v1/backoffice/vehicle-types", { params: filter });
        return response?.data?.data;
    }

    async function getVehicleTypeById(id: string) {
        const response = await instance.get<BaseResponse<VehicleType>>(`/v1/backoffice/vehicle-types/${id}`);
        return response?.data?.data;
    }

    async function getVehicleTypesShort(): Promise<ShortDto[]> {
        const response = await instance.get<BaseResponse<ShortDto[]>>("/v1/backoffice/vehicle-types/short");
        return response?.data?.data;
    }

    async function getAllVehicleTypesShortDto(): Promise<ShortDto[]> {
        try {
            setLoading(true);
            const response = await instance.get<BaseResponse<ShortDto[]>>('/v1/backoffice/vehicle-types/short');
            return response?.data?.data || [];
        } catch (error) {
            console.error('Erro ao buscar tipos de veículo:', error);
            return [];
        } finally {
            setLoading(false);
        }
    }

    return {
        loading,
        createVehicleType,
        updateVehicleType,
        deleteVehicleType,
        activateVehicleType,
        deactivateVehicleType,
        getVehicleTypes,
        getVehicleTypeById,
        getVehicleTypesShort,
        getAllVehicleTypesShortDto
    };
};

export default useVehicleTypeService;
